import {BookingsPreleaseProfileKey, BookingsProfileKey, BookingsReliefProfileKey} from './bookings/models/enums.models';

export const MODULE_DELIVERY_KEY: string = 'delivery';
export const MODULE_CONTRACT_CLOSING_KEY: string = 'contract-closing';
export const MODULE_NOTIFICATION_CENTER_KEY: string = 'notification-center';

export const PROFILE_DELIVERY_ASSISTANCE_CENTER_KEY: string = 'delivery_assistance_center';
export const PROFILE_DELIVERY_ASR_KEY: string = 'delivery_asr';
export const PROFILE_DELIVERY_ADMIN_KEY: string = 'delivery_admin';
export const PROFILE_DELIVERY_SUPERVISOR_KEY: string = 'delivery_supervisor';
export const PROFILE_DELIVERY_TEAM_MEMBER_KEY: string = 'delivery_team_member';
export const PROFILE_DELIVERY_READER_KEY: string = 'delivery_reader';
export const PROFILE_DELIVERY_SUPER_USER: string = 'delivery_center_super_user';

// CONTRACT_CLOSING
export const PROFILE_CONTRACT_CLOSING_ASSISTANCE_CENTER_KEY: string = 'contract_closing_assistance_center';
export const PROFILE_CONTRACT_CLOSING_SUPER_USER_KEY: string = 'contract-closing_center_super_user';
export const PROFILE_CONTRACT_CLOSING_ADMIN_KEY: string = 'contract_closing_admin';
export const PROFILE_CONTRACT_CLOSING_SUPERVISOR_KEY: string = 'contract_closing_supervisor';
export const PROFILE_CONTRACT_CLOSING_TEAM_MEMBER_KEY: string = 'contract_closing_team_member';
export const PROFILE_CONTRACT_CLOSING_RETURN_APPOINTMENT_MANAGER_KEY: string = 'contract_closing_return_appointment_manager';
export const PROFILE_CONTRACT_CLOSING_SURVEYOR_KEY: string = 'contract_closing_surveyor';
export const PROFILE_CONTRACT_CLOSING_BACK_OFFICE_KEY: string = 'contract_closing_back_office';
export const PROFILE_CONTRACT_CLOSING_SUPER_ADMIN_KEY: string = 'contract_closing_super_admin';

export const PROFILE_CLAIMS_ACCLAIMS: string = 'claims_team_member_acclaims';
export const PROFILE_CLAIMS_AON: string = 'claims_team_member_aon';
export const PROFILE_CLAIMS_CUSTOMER_SERVICE: string = 'claims_customer_service';
export const PROFILE_CLAIMS_COMPLAINT_READONLY: string = 'claims_complaint_readonly';
export const PROFILE_CLAIMS_PRACTICE_READONLY: string = 'claims_practice_readonly';
export const PROFILE_CLAIMS_PRACTICE_KEY: string = 'claims_team_member_practice';
export const PROFILE_CLAIMS_REPAIR_READONLY: string = 'claims_repair_readonly';

export const PROFILE_TYRES_CENTER_SUPER_USER: string = 'tyres_center_super_user';

export const PROFILE_LOGISTIC_TEAM_MEMBER_KEY: string = 'logistic_team_member';
export const PROFILE_LOGISTIC_FLOTTA_POOL_TRANSFER_KEY: string = 'logistic_pool_fleet_transfer';
export const PROFILE_LOGISTIC_CONSULTATION_KEY: string = 'logistic_consultation';
export const PROFILE_LOGISTIC_ADMIN_KEY: string = 'logistic_admin';
export const PROFILE_LOGISTIC_ASR_KEY: string = 'logistic_asr';
export const PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY: string = 'logistics_center_super_user';

export const PROFILE_INVOICING_CENTER_SUPER_USER_KEY: string = 'invoicing_center_super_user';

export const PROFILE_USER_CHANGE_ADMIN_KEY: string = 'change_user_admin';
export const PROFILE_USER_CHANGE_ASSISTANCE_CENTER_KEY: string = 'change_user_assistance_center';
export const PROFILE_USER_CHANGE_SUPER_USER_KEY: string = 'change_user_super_admin';
export const PROFILE_USER_CHANGE__CENTER_SUPER__USER__KEY: string = 'change-user_center_super_user';

export const PROFILE_CARGOS_TEAM_MEMBER:string = 'cargos_team_member';
export const PROFILES_CARGOS: string[] = [
	PROFILE_CARGOS_TEAM_MEMBER
]


export const PERMISSION_DELIVERY_DASHBOARD: string = 'delivery_dashboard';
export const PERMISSION_DELIVERY_ORDERS: string = 'delivery_orders';
export const PERMISSION_DELIVERY_ORDER_DETAIL: string = 'delivery_order_detail';
export const PERMISSION_DELIVERY_ORDER_DETAIL_DETAILS_READ: string = 'delivery_order_detail_details_read';
export const PERMISSION_DELIVERY_ORDER_DETAIL_DETAILS_WRITE: string = 'delivery_order_detail_details_write';
export const PERMISSION_DELIVERY_ORDER_DETAIL_ALERTS_READ: string = 'delivery_order_detail_alerts_read';
export const PERMISSION_DELIVERY_ORDER_DETAIL_ALERTS_WRITE: string = 'delivery_order_detail_alerts_write';
export const PERMISSION_DELIVERY_ORDER_DETAIL_PREPARATION_READ: string = 'delivery_order_detail_preparation_read';
export const PERMISSION_DELIVERY_ORDER_DETAIL_PREPARATION_WRITE: string = 'delivery_order_detail_preparation_write';
export const PERMISSION_DELIVERY_ORDER_DETAIL_DELIVERY_READ: string = 'delivery_order_detail_delivery_read';
export const PERMISSION_DELIVERY_ORDER_DETAIL_DELIVERY_WRITE: string = 'delivery_order_detail_delivery_write';
export const PERMISSION_DELIVERY_ORDER_DETAIL_ATTACHMENT_READ: string = 'delivery_order_detail_attachment_read';
export const PERMISSION_DELIVERY_ORDER_DETAIL_ATTACHMENT_WRITE: string = 'delivery_order_detail_attachment_write';
export const PERMISSION_DELIVERY_ALERTS_READ: string = 'delivery_alerts_read';
export const PERMISSION_DELIVERY_ALERTS_WRITE: string = 'delivery_alerts_write';
export const PERMISSION_DELIVERY_ALERTS_DETAIL_READ: string = 'delivery_alerts_detail_read';
export const PERMISSION_DELIVERY_ALERTS_DETAIL_WRITE: string = 'delivery_alerts_detail_write';
export const PERMISSION_DELIVERY_ALERTS_NEW: string = 'delivery_alerts_new';
export const PERMISSION_DELIVERY_APPOINTMENTS: string = 'delivery_appointments';
export const PERMISSION_DELIVERY_APPOINTMENTS_DETAIL_READ: string = 'delivery_appointments_detail_read';
export const PERMISSION_DELIVERY_APPOINTMENTS_DETAIL_WRITE: string = 'delivery_appointments_detail_write';
export const PERMISSION_DELIVERY_CONTACTS: string = 'delivery_contacts';
export const PERMISSION_CONTRACT_CLOSING_DASHBOARD: string = 'contract_closing_dashboard';
export const PERMISSION_CONTRACT_CLOSING_CONTRACTS: string = 'contract_closing_contracts';
export const PERMISSION_CONTRACT_CLOSING_APPOINTMENT_SPOT: string = 'contract_closing_appointment_spot';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_DETAILS: string = 'contract_closing_contract_detail_details';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_ALERT_READ: string = 'contract_closing_contract_detail_alert_read';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_ALERT_WRITE: string = 'contract_closing_contract_detail_alert_write';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_VEHICLE_EQUIPMENT_READ: string = 'contract_closing_contract_detail_vehicle_equipment_read';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_VEHICLE_EQUIPMENT_WRITE: string = 'contract_closing_contract_detail_vehicle_equipment_write';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_VEHICLE_SURVEY: string = 'contract_closing_contract_detail_vehicle_survey';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_CUSTOMER_READ: string = 'contract_closing_contract_detail_customer_read';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_DETAIL_CUSTOMER_WRITE: string = 'contract_closing_contract_detail_customer_write';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_ATTACHMENT_READ: string = 'contract_closing_contract_attachment_read';
export const PERMISSION_CONTRACT_CLOSING_CONTRACT_ATTACHMENT_WRITE: string = 'contract_closing_contract_attachment_write';
export const PERMISSION_CONTRACT_CLOSING_APPOINTMENTS: string = 'contract_closing_appointments';
export const PERMISSION_CONTRACT_CLOSING_APPOINTMENT_DETAIL_READ: string = 'contract_closing_appointment_detail_read';
export const PERMISSION_CONTRACT_CLOSING_APPOINTMENT_DETAIL_WRITE: string = 'contract_closing_appointment_detail_write';
export const PERMISSION_CONTRACT_CLOSING_SURVEY: string = 'contract_closing_survey';
export const PERMISSION_CONTRACT_CLOSING_MASSIVE_CLOSING: string = 'contract_closing_massive_closing';
export const PERMISSION_CONTRACT_CLOSING_CONTACTS: string = 'contract_closing_contacts';
export const PERMISSION_CONTRACT_CLOSING_RETURNED_ITEM: string = 'contract_closing_returned_item';

export const PERMISSION_CONTRACT_CLOSING_REBILLABLE_DATA: string = 'contract_closing_rebillable_data';
export const PERMISSION_CONTRACT_CLOSING_REBILLABLE: string = 'contract_closing_rebillable';

export const CROSS_PERMISSION_DIGITAL_SIGNATURE: string = 'digital_signature';
export const CROSS_PERMISSION_NOTIFICATION_WRITER: string = 'notification_writer';
export const CROSS_PERMISSION_NOTIFICATION_READER: string = 'notification_reader';
export const CROSS_PERMISSION_BREAKING_NEWS_BACKOFFICE: string = 'breaking_news_backoffice';
export const CROSS_PERMISSION_CALENDAR: string = 'calendar';


export const CROSS_PERMISSION_USER_INFORMATION: string = 'user_information';

export const CROSS_PERMISSION_DIGITAL_SIGNATURE_PROPERTY_CERTIFICATE_ALIAS: string = 'digital_signature_certificate_alias';
export const CROSS_PERMISSION_DIGITAL_SIGNATURE_PROPERTY_DOMAIN: string = 'digital_signature_certificate_domain';

// TODO modificare non appena viene rilasciata l'utenza delivery asr
export const DELIVERY_PROFILES: string[] = [PROFILE_DELIVERY_ASSISTANCE_CENTER_KEY, PROFILE_DELIVERY_ADMIN_KEY,
	PROFILE_DELIVERY_SUPERVISOR_KEY, PROFILE_DELIVERY_TEAM_MEMBER_KEY, PROFILE_DELIVERY_READER_KEY, PROFILE_DELIVERY_SUPER_USER];
export const DELIVERY_ASR_PROFILES: string[] = [PROFILE_DELIVERY_ASR_KEY];

export const PERMISSION_USER_CHANGE_DASHBOARD: string = 'change_user_dashboard';
export const PERMISSION_USER_CHANGE_APPOINTMENTS_LIST: string = 'change_user_appointments_list';
export const PERMISSION_USER_CHANGE_APPOINTMENT_READ: string = 'change_user_appointment_detail_read';
export const PERMISSION_USER_CHANGE_APPOINTMENT_WRITE: string = 'change_user_appointment_detail_write';
export const PERMISSION_USER_CHANGE_CREATE_APPOINTMENT: string = 'change_user_create_return_appointment';
export const PERMISSION_USER_CHANGE_CREATE_DELIVERY_APPOINTMENT: string = 'change_user_create_delivery_appointment';
export const PERMISSION_USER_CHANGE_PROCEDURE_LIST: string = 'change_user_procedure_list';
export const PERMISSION_USER_CHANGE_PROCEDURE_READ: string = 'change_user_procedure_detail_read';
export const PERMISSION_USER_CHANGE_PROCEDURE_UPDATE: string = 'change_user_procedure_detail_update';
export const PERMISSION_USER_CHANGE_PAPER_SIGNATURE: string = 'change_user_paper_signature';
export const PERMISSION_USER_CHANGE_STATUS_UPDATE: string = 'change_user_status_update';

// TODO - BISOGNA MAPPARE ANCHE ALTRI PROFILI DI BOOKINGS

export const PROFILE_BOOKINGS_RELIEF_ASSISTANCE_CENTER: string = 'module_relief_assistance_center';
export const PROFILE_BOOKINGS_RELIEF_RAC_CENTER: string = 'module_relief_rac_center';
export const PROFILE_BOOKINGS_RELIEF_BOOKINGS_TEAM: string = 'module_relief_bookings_team';
export const PROFILE_BOOKINGS_RELIEF_BOOKINGS_TEAM_SUPERVISOR: string = 'module_relief_bookings_team_supervisor';
export const PROFILE_BOOKINGS_RELIEF_CUSTOMER_FINANCE: string = 'module_relief_customer_finance';
export const PROFILE_BOOKINGS_RELIEF_CUSTOMER_SERVICE: string = 'module_relief_customer_service';
export const PROFILE_BOOKINGS_RELIEF_CUSTOMER_SERVICE_SUPERVISOR: string = 'module_relief_customer_service_supervisor';

export const PROFILE_BOOKINGS_PRELEASE_ASSISTANCE_CENTER: string = 'module_prelease_assistance_center';
export const PROFILE_BOOKINGS_PRELEASE_RAC_CENTER: string = 'module_prelease_rac_center';
export const PROFILE_BOOKINGS_PRELEASE_BOOKINGS_TEAM_SUPERVISOR: string = 'module_prelease_bookings_team_supervisor';
export const PROFILE_BOOKINGS_PRELEASE_BOOKINGS_TEAM: string = 'module_prelease_bookings_team';

// Bookings Relief Backoffice
export const NEMO_MOBILITY_BOOKINGS_RELIEF_BACKOFFICE: string[] = [
	PROFILE_BOOKINGS_RELIEF_BOOKINGS_TEAM,
	PROFILE_BOOKINGS_RELIEF_BOOKINGS_TEAM_SUPERVISOR,
	PROFILE_BOOKINGS_RELIEF_CUSTOMER_FINANCE,
	PROFILE_BOOKINGS_RELIEF_CUSTOMER_SERVICE,
	PROFILE_BOOKINGS_RELIEF_CUSTOMER_SERVICE_SUPERVISOR,
];

// MOBILITY BOOKINGS
export const NEMO_MOBILITY_BOOKINGS_RELIEF_CA_PILOT: string = 'module_relief_assistance_center_pilot';

// Profili che possono vedere le prenotazioni "Da richiedere"
export const NEMO_MOBILITY_BOOKINGS: string[] = [
	...NEMO_MOBILITY_BOOKINGS_RELIEF_BACKOFFICE,
	NEMO_MOBILITY_BOOKINGS_RELIEF_CA_PILOT,
	PROFILE_BOOKINGS_RELIEF_ASSISTANCE_CENTER,
];


export const MODULE_CHANGE_USER_KEY: string = 'change-user';
export const MODULE_TYRES_KEY: string = 'tyres';
export const MODULE_INVOICING_KEY: string = 'invoicing';
export const MODULE_AUTHORITY_KEY: string = 'authority';
export const MODULE_BOOKINGS_KEY: string = 'bookings';
export const MODULE_CLAIMS_KEY: string = 'claims';
export const MODULE_TYRE: string = 'tyres';

export const PROFILE_INVOICING_ASSISTANCE_CENTER_KEY: string = 'invoicing_assistance_center';
export const PROFILE_INVOICING_ADMIN_KEY: string = 'invoicing_admin';

export const PROFILE_PUBLIC_USER_KEY: string = 'claims_public_user';
export const PROFILE_CLAIMS_ADMIN_KEY: string = 'claims_admin';
export const PROFILE_CLAIMS_CUSTOM_ADMIN_KEY: string = 'claims_team_member_theft_external_dash';
export const PROFILES_CLAIMS_DEKRA_READONLY_KEY: string = 'claims_dekra_readonly';
export const PROFILE_CLAIMS_SUPERVISOR_KEY: string = 'claims_supervisor';
export const PROFILE_CLAIMS_EXTERNAL_KEY: string = 'claims_team_member_external';
export const PROFILE_CLAIMS_MYALD_KEY: string = 'claims_myald';
export const PROFILE_CLAIMS_EXTERNAL_SYSTEM_KEY: string = 'claims_external';
export const PROFILE_CLAIMS_REPAIR_KEY: string = 'claims_team_member_repair';
export const PROFILE_CLAIMS_REPAIR_SUPERVISOR_KEY: string = 'claims_supervisor_repair';
export const PROFILE_CLAIMS_THEFT_ALD: string = 'claims_team_member_theft';
export const PROFILE_CLAIMS_THEFT_EXTERNAL: string = 'claims_team_member_theft_external';
export const PROFILES_CLAIMS_AUTHORITY_KEY: string = 'claims_authority';	

// PROFILI CLAIMS BROKER
export const PROFILE_CLAIMS_BROKER__38: string =   'claims_broker__38';
export const PROFILE_CLAIMS_BROKER__38_5: string = 'claims_broker__38_5';
export const PROFILE_CLAIMS_BROKER__5_38_57_34: string = 'claims_broker__5_38_57_34';
export const PROFILE_CLAIMS_BROKER__864_344: string = 'claims_broker__864_344';
export const PROFILE_CLAIMS_BROKER__486: string = 'claims_broker__486';
// PROFILI CLAIMS LEGAL
export const PROFILE_CLAIMS_LEGAL__1: string = 'claims_legal__1';
export const PROFILE_CLAIMS_LEGAL__1_8: string = 'claims_legal__1_8';
export const PROFILE_CLAIMS_LEGAL__8: string = 'claims_legal__8';
export const PROFILE_CLAIMS_LEGAL__20: string = 'claims_legal__20';
// PROFILI CLAIMS FLUSSO
export const PROFILE_CLAIMS_FLOW__FUL: string = 'claims_flow__FUL';
export const PROFILE_CLAIMS_FLOW__FNI: string = 'claims_flow__FNI';
export const PROFILE_CLAIMS_FLOW__FCM: string = 'claims_flow__FCM';

// Lista profili
export const PROFILE_CLAIMS_BROKER_LIST: string[] = [PROFILE_CLAIMS_BROKER__38, PROFILE_CLAIMS_BROKER__38_5, PROFILE_CLAIMS_BROKER__5_38_57_34, PROFILE_CLAIMS_BROKER__864_344, PROFILE_CLAIMS_BROKER__486];
export const PROFILE_CLAIMS_LEGAL_LIST : string[] = [PROFILE_CLAIMS_LEGAL__1, PROFILE_CLAIMS_LEGAL__1_8, PROFILE_CLAIMS_LEGAL__8, PROFILE_CLAIMS_LEGAL__20];
export const PROFILE_CLAIMS_FLOW_LIST  : string[] = [PROFILE_CLAIMS_FLOW__FUL, PROFILE_CLAIMS_FLOW__FNI, PROFILE_CLAIMS_FLOW__FCM];

export const PROFILE_CLAIMS_READONLY_LIST: string[] = [...PROFILE_CLAIMS_BROKER_LIST, ...PROFILE_CLAIMS_LEGAL_LIST];

export const PROFILE_TYRES_ASSISTANCE_CENTER_KEY: string = 'tyres_assistance_center';
export const PROFILE_TYRES_ADMIN_KEY: string = 'tyres_admin';
export const PROFILE_TYRE_CUSTOMER_SERVICE_KEY: string = 'tyres_customer_service';
export const PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY: string = 'tyres_pool_fleet';
export const PERMISSION_INVOICING_DASHBOARD: string = 'invoicing_dashboard';
export const PERMISSION_INVOICING_TASKS_AND_INVOICE_LIST: string = 'invoicing_tasks_and_invoice_list';
export const PERMISSION_INVOICING_TASKS_EXPORT: string = 'invoicing_tasks_list_excel_export';
export const PERMISSION_INVOICING_INVOICE_EXPORT: string = 'invoicing_invoice_list_excel_export';
export const PERMISSION_INVOICING_INVOICE_CREATION: string = 'invoicing_invoice_creation';
export const PERMISSION_INVOICING_TASK_DETAIL: string = 'invoicing_task_detail';

export const PERMISSION_TYRE_DASHBOARD: string = 'tyre_dashboard';

export enum AuthorityUsersPermissions {
	authority_appointment_detail_read = 'authority_appointment_detail_read',
	authority_appointment_detail_write = 'authority_appointment_detail_write',
	authority_appointments_list = 'authority_appointments_list',
	authority_assistance_center_cross_search = 'authority_assistance_center_cross_search',
	authority_attachments_read = 'authority_attachments_read',
	authority_attachments_write = 'authority_attachments_write',
	authority_claims_integration = 'authority_claims_integration',
	authority_claims_read = 'authority_claims_read',
	authority_commodity_information = 'authority_commodity_information',
	authority_consip_approving = 'authority_consip_approving',
	authority_consip_extra_fee = 'authority_consip_extra_fee',
	authority_contracts_search = 'authority_contracts_search',
	authority_dashboard = 'authority_dashboard',
	authority_dealer_cross_search = 'authority_dealer_cross_search',
	authority_dealer_dashboard = 'authority_dealer_dashboard',
	supervisor_channeling = 'supervisor_channeling',
	authority_dealer_detail_read = 'authority_dealer_detail_read',
	authority_dealer_refresh_quotation = 'authority_dealer_refresh_quotation',
	authority_dealers_list = 'authority_dealers_list',
	authority_dealers_update = 'authority_dealers_update',
	authority_dossier_closing = 'authority_dossier_closing',
	authority_dossier_integration = 'authority_dossier_integration',
	authority_dossiers_accepting_data_update = 'authority_dossiers_accepting_data_update',
	authority_dossiers_attachments_write = 'authority_dossiers_attachments_write',
	authority_dossiers_delivery_prediction_date_update = 'authority_dossiers_delivery_prediction_date_update',
	authority_dossiers_priority_update = 'authority_dossiers_priority_update',
	authority_dossiers_read = 'authority_dossiers_read',
	authority_dossiers_write = 'authority_dossiers_write',
	authority_history_list = 'authority_history_list',
	authority_invoicing_read = 'authority_invoicing_read',
	authority_invoicing_write = 'authority_invoicing_write',
	authority_orders_read = 'authority_orders_read',
	authority_orders_send = 'authority_orders_send',
	authority_orders_write = 'authority_orders_write',
	authority_parts_order_snapshots_read = 'authority_parts_order_snapshots_read',
	authority_poc_quotators = 'authority_poc_quotators',
	authority_quotation_approve = 'authority_quotation_approve',
	authority_quotation_entries_status_arrived = 'authority_quotation_entries_status_arrived',
	authority_quotation_entries_update = 'authority_quotation_entries_update',
	authority_quotation_snapshots_read = 'authority_quotation_snapshots_read',
	authority_quotation_super_approve = 'authority_quotation_super_approve',
	authority_quotations_delete = 'authority_quotations_delete',
	authority_quotations_read = 'authority_quotations_read',
	authority_quotations_send = 'authority_quotations_send',
	authority_quotations_working_management = 'authority_quotations_working_management',
	authority_quotations_write = 'authority_quotations_write',
	authority_shipping_management = 'authority_shipping_management',
	authority_suppliers_management = 'authority_suppliers_management',
	authority_working_franchise_update = 'authority_working_franchise_update',
	authority_workings_delete = 'authority_workings_delete',
	authority_workings_read = 'authority_workings_read',
	authority_workings_write = 'authority_workings_write',
	carglass_attachment = 'carglass_attachment',
	carglass_claims = 'carglass_claims',
	carglass_dashboard = 'carglass_dashboard',
	carglass_read = 'carglass_read',
	carglass_suppliers_management = 'carglass_suppliers_management',
	carglass_write = 'carglass_write',
	authority_admin_dashboard = 'authority_admin_dashboard',
	authority_supervisor_dashboard = 'authority_supervisor_dashboard',
	authority_appointment_dashboard = 'authority_appointment_dashboard',
	authority_administrative_practice_dashboard = 'authority_administrative_practice_dashboard',
	authority_merged_dashboard = 'authority_merged_dashboard',
	authority_approve = 'authority_approve',
	authority_super_approve = 'authority_super_approve',
	authority_assistance_center = 'authority_assistance_center',
	authority_center_super_user = 'authority_center_super_user',
	authority_wreck_onerous_expired_download_pdf = 'authority_wreck_onerous_expired_download_pdf',
	authority_dossier_note_read = 'authority_dossier_note_read',
	authority_dossier_note_write = 'authority_dossier_note_write',
	authority_dossiers_filter_type_read = 'authority_dossiers_filter_type_read',
	authority_quotation_entries_remove = 'authority_quotation_entries_remove',
	authority_order_entries_remove = 'authority_order_entries_remove',
	authority_can_create_dossier_general_note = 'authority_can_create_dossier_general_note',
	authority_can_create_order_general_note = 'authority_can_create_order_general_note',
	authority_can_read_dossier_general_note = 'authority_can_read_dossier_general_note',
	authority_can_read_order_general_note = 'authority_can_read_order_general_note',
	authority_dossier_consultation = 'authority_dossier_consultation',
	//fleet manager
	authority_administrative_practice_read = 'authority_administrative_practice_read',
	authority_administrative_practice_send_write = 'authority_administrative_practice_send_write',
	authority_administrative_practice_reply_write = 'authority_administrative_practice_reply_write',
	authority_can_generate_documents = 'authority_can_generate_documents'
}

/*
 *  PROFILI AUTHORITY
 */ 
// export const AUTHORITY_CENTER_SUPER_USER: string = 'authority_center_super_user';
// export const AUTHORITY_SUPERVISOR_USER: string = 'authority_supervisor';
// export const AUTHORITY_FIELD_OPERATOR_USER: string = 'authority_field_operator';
// export const AUTHORITY_ASSISTANCE_CENTER: string = 'authority_assistance_center';

export const AUTHORITY_BUSINESS_OPERATOR_USER					 : string = 'authority_business_operator';
export const AUTHORITY_CREDIT_COLLECTION_OPERATOR_USER : string = 'authority_credit_collection_operator';
export const AUTHORITY_AUDIT_OPERATOR_USER					 	 : string = 'authority_audit_operator';
export const AUTHORITY_OPERATOR_USER					 				 : string = 'authority_operator';
export const AUTHORITY_ASSISTANCE_CENTER_READ_USER		 : string = 'authority_assistance_center_read';
export const AUTHORITY_ASSISTANCE_CENTER_TEST_USER		 : string = 'authority_assistance_center_test';
export const AUTHORITY_READER_USER					 					 : string = 'authority_reader';
export const AUTHORITY_DEALER_USER					 					 : string = 'authority_dealer';
export const AUTHORITY_EDIDOMUS_USER					 				 : string = 'authority_edidomus';
export const AUTHORITY_LEADER_DEALER_USER					 		 : string = 'authority_leader_dealer';
export const AUTHORITY_DEALER_TEST_USER					 			 : string = 'authority_dealer_test';
export const AUTHORITY_ADMIN_TEST_USER					 			 : string = 'authority_admin_test';
export const AUTHORITY_CENTER_SUPER_USER    					 : string = 'authority_center_super_user';
export const AUTHORITY_INVOICING_OPERATOR_USER				 : string = 'authority_invoicing_operator';
export const AUTHORITY_FLEET_ADMIN_OPERATOR_USER			 : string = 'authority_fleet_admin_operator';
export const AUTHORITY_TECH_SERVICES_OPERATOR_USER		 : string = 'authority_tech_services_operator';
export const AUTHORITY_MASTER_DEALER_USER					 		 : string = 'authority_master_dealer';
export const AUTHORITY_ASSISTANCE_CENTER    					 : string = 'authority_assistance_center';
export const AUTHORITY_APPOINTMENT_MANAGEMENT_USER		 : string = 'authority_appointment_management';
export const AUTHORITY_HR_OPERATOR_USER					 			 : string = 'authority_hr_operator';
export const AUTHORITY_RELIEF_OPERATOR_USER					 	 : string = 'authority_relief_operator';
export const AUTHORITY_SUPER_ADMIN_USER					 			 : string = 'authority_super_admin';
export const AUTHORITY_ADMIN_USER					 						 : string = 'authority_admin';
export const AUTHORITY_CLAIMS_OPERATOR_USER					 	 : string = 'authority_claims_operator';
export const AUTHORITY_CONTROLLING_OPERATOR_USER			 : string = 'authority_controlling_operator';
export const AUTHORITY_FIELD_OPERATOR_USER					 	 : string = 'authority_field_operator';
export const AUTHORITY_FLEET_ADMIN_SUPERVISOR_USER		 : string = 'authority_fleet_admin_supervisor';
export const AUTHORITY_IT_ADMIN_USER					 				 : string = 'authority_it_admin';
export const AUTHORITY_POOL_OPERATOR_USER					 		 : string = 'authority_pool_operator';
export const AUTHORITY_POOL_SUPERVISOR_USER					 	 : string = 'authority_pool_supervisor';
export const AUTHORITY_PRELEASE_OPERATOR_USER					 : string = 'authority_prelease_operator';
export const AUTHORITY_PRICING_OPERATOR_USER					 : string = 'authority_pricing_operator';
export const AUTHORITY_SUPERVISOR_USER					 			 : string = 'authority_supervisor';

// Rimozione bottone crea intervento e crea intervento da dentro la sezione appuntamenti
// Rimozione bottone crea pratica, all'interno del dettaglio intervento, se l'intervento ha il campo stop_and_go_id valorizzato
export const AUTHORITY_ASSISTANCE_CENTER_PILOT: string[] = ['authority_assistance_center_pilot'];

// Deve essere uguale a AUTHORITY_ASSISTANCE_CENTER, tranne per il controllo sulla P.IVA
export const AUTHORITY_ASSISTANCE_CENTER_NETWORK = 'authority_assistance_center_network';

export const AUTHORITY_PROFILES: string[] = [
	...AUTHORITY_ASSISTANCE_CENTER_PILOT, AUTHORITY_LEADER_DEALER_USER, AUTHORITY_DEALER_USER, AUTHORITY_DEALER_TEST_USER, AUTHORITY_MASTER_DEALER_USER, AUTHORITY_BUSINESS_OPERATOR_USER, AUTHORITY_CREDIT_COLLECTION_OPERATOR_USER, AUTHORITY_AUDIT_OPERATOR_USER, AUTHORITY_OPERATOR_USER, AUTHORITY_ASSISTANCE_CENTER_READ_USER, AUTHORITY_ASSISTANCE_CENTER_TEST_USER, AUTHORITY_READER_USER, AUTHORITY_EDIDOMUS_USER, AUTHORITY_ADMIN_TEST_USER, AUTHORITY_CENTER_SUPER_USER, AUTHORITY_INVOICING_OPERATOR_USER, AUTHORITY_FLEET_ADMIN_OPERATOR_USER, AUTHORITY_TECH_SERVICES_OPERATOR_USER, AUTHORITY_ASSISTANCE_CENTER, AUTHORITY_APPOINTMENT_MANAGEMENT_USER, AUTHORITY_HR_OPERATOR_USER, AUTHORITY_RELIEF_OPERATOR_USER, AUTHORITY_SUPER_ADMIN_USER, AUTHORITY_ADMIN_USER, AUTHORITY_CLAIMS_OPERATOR_USER, AUTHORITY_CONTROLLING_OPERATOR_USER, AUTHORITY_FIELD_OPERATOR_USER, AUTHORITY_FLEET_ADMIN_SUPERVISOR_USER, AUTHORITY_IT_ADMIN_USER, AUTHORITY_POOL_OPERATOR_USER, AUTHORITY_POOL_SUPERVISOR_USER, AUTHORITY_PRELEASE_OPERATOR_USER, AUTHORITY_PRICING_OPERATOR_USER, AUTHORITY_SUPERVISOR_USER, AUTHORITY_ASSISTANCE_CENTER_NETWORK
];
export const AUTHORITY_BASE_PROFILES: string[] = [
	...AUTHORITY_ASSISTANCE_CENTER_PILOT, AUTHORITY_LEADER_DEALER_USER, AUTHORITY_BUSINESS_OPERATOR_USER, AUTHORITY_CREDIT_COLLECTION_OPERATOR_USER, AUTHORITY_AUDIT_OPERATOR_USER, AUTHORITY_OPERATOR_USER, AUTHORITY_ASSISTANCE_CENTER_READ_USER, AUTHORITY_ASSISTANCE_CENTER_TEST_USER, AUTHORITY_READER_USER, AUTHORITY_EDIDOMUS_USER, AUTHORITY_ADMIN_TEST_USER, AUTHORITY_CENTER_SUPER_USER, AUTHORITY_INVOICING_OPERATOR_USER, AUTHORITY_FLEET_ADMIN_OPERATOR_USER, AUTHORITY_TECH_SERVICES_OPERATOR_USER, AUTHORITY_ASSISTANCE_CENTER, AUTHORITY_APPOINTMENT_MANAGEMENT_USER, AUTHORITY_HR_OPERATOR_USER, AUTHORITY_RELIEF_OPERATOR_USER, AUTHORITY_SUPER_ADMIN_USER, AUTHORITY_ADMIN_USER, AUTHORITY_CLAIMS_OPERATOR_USER, AUTHORITY_CONTROLLING_OPERATOR_USER, AUTHORITY_FIELD_OPERATOR_USER, AUTHORITY_FLEET_ADMIN_SUPERVISOR_USER, AUTHORITY_IT_ADMIN_USER, AUTHORITY_POOL_OPERATOR_USER, AUTHORITY_POOL_SUPERVISOR_USER, AUTHORITY_PRELEASE_OPERATOR_USER, AUTHORITY_PRICING_OPERATOR_USER, AUTHORITY_SUPERVISOR_USER
]
export const AUTHORITY_DEALER_PROFILES: string[] = [
	AUTHORITY_DEALER_USER, AUTHORITY_DEALER_TEST_USER, AUTHORITY_MASTER_DEALER_USER
]

export const CROSS_PERMISSION_ACADEMY: string = 'academy';
export const PROFILE_CLAIMS_PRACTICE_CAR_KEY: string = 'claims_team_member_administrative';
export const PERMISSION_CLAIMS_REPAIR_MANAGE: string = 'claims_repair_manage';
export const PERMISSION_CLAIMS_REPAIR_ASSIGN: string = 'claims_repair_assign';

export const CONTRACT_CLOSING_SPO_PROFILES: string[] = [PROFILE_CONTRACT_CLOSING_ASSISTANCE_CENTER_KEY, PROFILE_CONTRACT_CLOSING_SUPER_USER_KEY];
//export const CONTRACT_CLOSING_SU_PROFILES: string[] = ['contract-closing_center_super_user'];
export const CONTRACT_CLOSING_DKO_PROFILES: string[] = [PROFILE_CONTRACT_CLOSING_SURVEYOR_KEY];
export const CONTRACT_CLOSING_DK_BO_PROFILES: string[] = [PROFILE_CONTRACT_CLOSING_BACK_OFFICE_KEY];
export const CONTRACT_CLOSING_DKC_PROFILES: string[] = [PROFILE_CONTRACT_CLOSING_RETURN_APPOINTMENT_MANAGER_KEY];
export const CONTRACT_CLOSING_ALD_PROFILES: string[] = [PROFILE_CONTRACT_CLOSING_ADMIN_KEY, PROFILE_CONTRACT_CLOSING_SUPERVISOR_KEY, PROFILE_CONTRACT_CLOSING_TEAM_MEMBER_KEY, PROFILE_CONTRACT_CLOSING_SUPER_ADMIN_KEY];

export const CLAIMS_ADMIN_PROFILES: string[] = [PROFILE_CLAIMS_ADMIN_KEY];
export const CLAIMS_CUSTOM_ADMIN_PROFILES: string[] = [PROFILE_CLAIMS_CUSTOM_ADMIN_KEY, ...PROFILE_CLAIMS_FLOW_LIST];
export const CLAIMS_SUPERVISOR_PROFILES: string[] = [PROFILE_CLAIMS_SUPERVISOR_KEY];
export const CLAIMS_OLSA_PROFILES: string[] = [PROFILE_CLAIMS_EXTERNAL_KEY];
export const CLAIMS_DRIVER_PROFILES: string[] = [PROFILE_CLAIMS_MYALD_KEY];
export const CLAIMS_PUBLIC_PROFILES: string[] = [PROFILE_PUBLIC_USER_KEY];
export const CLAIMS_MYALD_PROFILES: string[] = [PROFILE_CLAIMS_MYALD_KEY];
export const CLAIMS_EXTERNAL_SYSTEM_PROFILES: string[] = [PROFILE_CLAIMS_EXTERNAL_SYSTEM_KEY, PROFILE_CLAIMS_ADMIN_KEY, PROFILE_CLAIMS_COMPLAINT_READONLY, PROFILES_CLAIMS_DEKRA_READONLY_KEY, ...PROFILE_CLAIMS_READONLY_LIST];
export const CLAIMS_REPAIR_PROFILES: string[] = [PROFILE_CLAIMS_REPAIR_KEY, PROFILE_CLAIMS_REPAIR_SUPERVISOR_KEY, PROFILE_CLAIMS_REPAIR_READONLY];
export const CLAIMS_THEFT_PROFILES: string[] = [PROFILE_CLAIMS_THEFT_ALD];
export const CLAIMS_COMPLAINT_PROFILES: string[] = [PROFILE_CLAIMS_COMPLAINT_READONLY, PROFILES_CLAIMS_AUTHORITY_KEY, PROFILE_CLAIMS_THEFT_EXTERNAL, PROFILE_CLAIMS_CUSTOMER_SERVICE, PROFILE_CLAIMS_AON, PROFILES_CLAIMS_DEKRA_READONLY_KEY, ...PROFILE_CLAIMS_READONLY_LIST];
export const CLAIMS_PRACTICE_PROFILES: string[] = [PROFILE_CLAIMS_PRACTICE_KEY, PROFILE_CLAIMS_PRACTICE_READONLY];
export const CLAIMS_PRACTICE_CAR_PROFILES: string[] = [PROFILE_CLAIMS_PRACTICE_CAR_KEY];
export const PUBLIC_USER_PROFILES: string[] = [PROFILE_PUBLIC_USER_KEY];

export const INVOICING_PROFILES: string[] = [PROFILE_INVOICING_ASSISTANCE_CENTER_KEY, PROFILE_INVOICING_ADMIN_KEY, PROFILE_INVOICING_CENTER_SUPER_USER_KEY];
export const TYRES_PROFILES: string[] = [PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_ADMIN_KEY, PROFILE_TYRE_CUSTOMER_SERVICE_KEY, PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY, PROFILE_TYRES_CENTER_SUPER_USER];
export const LOGISTICS_PROFILES: string[] = [PROFILE_LOGISTIC_TEAM_MEMBER_KEY, PROFILE_LOGISTIC_ADMIN_KEY, PROFILE_LOGISTIC_ASR_KEY, PROFILE_LOGISTIC_CONSULTATION_KEY, PROFILE_CLAIMS_ADMIN_KEY, PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY, PROFILE_LOGISTIC_FLOTTA_POOL_TRANSFER_KEY];


export const USER_CHANGE_ADMIN_PROFILES: string[] = [PROFILE_USER_CHANGE_ADMIN_KEY];
export const USER_CHANGE_SP_PROFILES: string[] = [PROFILE_USER_CHANGE_ASSISTANCE_CENTER_KEY, PROFILE_USER_CHANGE_SUPER_USER_KEY, PROFILE_USER_CHANGE__CENTER_SUPER__USER__KEY];

export enum LogisticsUsersPermissions {
	logistic_transport_management = 'logistic_transport_management',
	logistic_transport_detail = 'logistic_transport_detail',
	logistic_update_transport = 'logistic_update_transport',
	logistic_update_data_transport = 'logistic_update_data_transport',
	logistic_update_status_transport = 'logistic_update_status_transport',
	logistic_create_transport = 'logistic_create_transport',
}

export const PROFILE_ADMINISTRATION_SUPERADMIN_KEY: string = 'administration_rules_superadmin';
export const PROFILE_ADMINISTRATION_ADMIN_KEY: string = 'administration_rules_admin';
export const ADMINISTRATION_RULES_PROFILES: string[] = [PROFILE_ADMINISTRATION_SUPERADMIN_KEY, PROFILE_ADMINISTRATION_ADMIN_KEY];


//Profile testing - Rug
export const PROFILE_ADMINISTRATION_CHANNELING_RULES_SUPERADMIN: string = 'administration_channeling_rules_superadmin';
export const PROFILE_ADMINISTRATION_CHANNELING_RULES_ADMIN: string = "administration_channeling_rules_admin";
//
export const PROFILE_ADMINISTRATION_CHANNELING_ADMIN_KEY: string = 'administration_channeling_admin';
export const PROFILE_ADMINISTRATION_CHANNELING_SUPERADMIN_KEY: string = 'administration_channeling_superadmin';
export const ADMINISTRATION_CHANNELING_PROFILES: string[] = [PROFILE_ADMINISTRATION_CHANNELING_RULES_ADMIN, PROFILE_ADMINISTRATION_CHANNELING_RULES_SUPERADMIN, PROFILE_ADMINISTRATION_CHANNELING_SUPERADMIN_KEY, PROFILE_ADMINISTRATION_CHANNELING_ADMIN_KEY];

// Gestione Utenti
export const PROFILE_ADMINISTRATION_USER_MANAGEMENT_SUPERADMIN_KEY: string = 'administration_user_management_superadmin';
export const PROFILE_ADMINISTRATION_USER_MANAGEMENT_ADMIN_KEY: string = 'administration_user_management_reader';
export const ADMINISTRATION_USER_MANAGEMENT_PROFILES: string[] = [PROFILE_ADMINISTRATION_USER_MANAGEMENT_SUPERADMIN_KEY, PROFILE_ADMINISTRATION_USER_MANAGEMENT_ADMIN_KEY];

/*
 * 	PROFILI MOBILITY
 */ 


export const MOBILITY_MYMOBILITY_PROFILE = 'MYMOBILITY';

export const AUTHORITY_MOBILITY_BACKOFFICE_USER = 'authority_mobility_backoffice';
// Ruolo manager LeasePlan per la gestione delle pratiche di lp-mobility
export const LPM_INT_MANAGER = 'LPM_INT_MANAGER';
	//  Ruolo operatore standard LeasePlan per la gestione delle pratiche di lp-mobility
export const LPM_INT_STANDARD	= 'LPM_INT_STANDARD';
// Ruolo supervisor LeasePlan per la gestione delle pratiche di lp-mobility
export const LPM_INT_SUPERVISOR	= 'LPM_INT_SUPERVISOR';
// Ruolo operatore del Network officine per la gestione delle pratiche di lp-mobility
export const LPM_NET_STANDARD	= 'LPM_NET_STANDARD';
// Ruolo Operatore azienda outsourcer per la gestione delle pratiche di lp-mobility
export const LPM_OUT_STANDARD	= 'LPM_OUT_STANDARD';
// Nuovo profilo capofila - deve avere la stessa visualizzazione di MYMOBILITY
export const MOBILITY_NETWORK_PROFILE	= 'mobility_network';

// Può vedere solo Dashboard e Pratiche, ha varie limitazioni sul dettaglio della pratica
// Quando si apre il profilo dal menù a sinistra, si apre anche un'altra scheda verso Mobility
export const MOBILITY_MYMOBILITY_PROFILE_USER: string[] = [MOBILITY_MYMOBILITY_PROFILE, MOBILITY_NETWORK_PROFILE];

export const NEMO_MOBILITY_AUTHORITY_BACKOFFICE: string[] = [
	AUTHORITY_MOBILITY_BACKOFFICE_USER,
	LPM_INT_MANAGER,
	LPM_INT_STANDARD,
	LPM_INT_SUPERVISOR,
	LPM_NET_STANDARD,
	LPM_OUT_STANDARD,
];
// Tutti i profili mobility: myMobility + backoffice admin + network
export const MOBILITY_PROFILES: string[] = [...MOBILITY_MYMOBILITY_PROFILE_USER, ...NEMO_MOBILITY_AUTHORITY_BACKOFFICE, MOBILITY_NETWORK_PROFILE];

export enum AdministrationUserPermissions {
	// RULES
	administration_rules_can_read_set = 'administration_rules_can_read_set',
	administration_rules_can_create_set = 'administration_rules_can_create_set',
	administration_rules_can_edit_set = 'administration_rules_can_edit_set',
	administration_rules_can_delete_set = 'administration_rules_can_delete_set',
	administration_rules_can_block_set = 'administration_rules_can_block_set',
	administration_rules_can_unblock_set = 'administration_rules_can_unblock_set',
	administration_rules_can_edit_set_json_schema = 'administration_rules_can_edit_set_json_schema',
	administration_rules_can_create_set_rules = 'administration_rules_can_create_set_rules',
	administration_rules_can_edit_set_rules = 'administration_rules_can_edit_set_rules',
	administration_rules_can_delete_set_rules = 'administration_rules_can_delete_set_rules',
	administration_rules_can_change_set_rules_status = 'administration_rules_can_change_set_rules_status',
	administration_rules_can_order_set_rules = 'administration_rules_can_order_set_rules',
	administration_rules_can_create_set_rule_conditions = 'administration_rules_can_create_set_rule_conditions',
	administration_rules_can_edit_set_rule_conditions = 'administration_rules_can_edit_set_rule_conditions',
	administration_rules_can_delete_set_rule_conditions = 'administration_rules_can_delete_set_rule_conditions',
	// CHANNELING
	administration_channeling_can_create_group = 'administration_channeling_can_create_group',
	administration_channeling_can_update_group = 'administration_channeling_can_update_group',
	administration_channeling_can_get_groups = 'administration_channeling_can_get_groups',
	administration_channeling_can_get_group = 'administration_channeling_can_get_group',
	administration_channeling_can_delete_groups = 'administration_channeling_can_delete_groups',
	administration_channeling_can_get_rules = 'administration_channeling_can_get_rules',
	administration_channeling_can_create_rule = 'administration_channeling_can_create_rule',
	administration_channeling_can_update_rule = 'administration_channeling_can_update_rule',
	administration_channeling_can_create_condition = 'administration_channeling_can_create_condition',
	administration_channeling_can_update_condition = 'administration_channeling_can_update_condition',
	administration_channeling_can_delete_condition = 'administration_channeling_can_delete_condition',
	administration_channeling_can_get_group_rules = 'administration_channeling_can_get_group_rules',
	administration_channeling_can_activate_rules = 'administration_channeling_can_activate_rules',
	administration_channeling_can_deactivate_rules = 'administration_channeling_can_deactivate_rules',
	administration_channeling_can_delete_rules = 'administration_channeling_can_delete_rules',
	administration_channeling_can_activate_group_rules = 'administration_channeling_can_activate_group_rules',
	administration_channeling_can_deactivate_group_rules = 'administration_channeling_can_deactivate_group_rules',
	administration_channeling_can_delete_group_rules = 'administration_channeling_can_delete_group_rules',
	administration_channeling_can_sort_rules = 'administration_channeling_can_sort_rules',
	administration_channeling_can_clone_rules = 'administration_channeling_can_clone_rules',
	administration_channeling_can_get_profiles = 'administration_channeling_can_get_profiles',
	administration_channeling_can_get_users = 'administration_channeling_can_get_users',
	administration_channeling_can_get_user_profile = 'administration_channeling_can_get_user_profile',
	administration_channeling_can_add_user = 'administration_channeling_can_add_user',
	administration_channeling_can_remove_user = 'administration_channeling_can_remove_user',
	administration_channeling_can_get_engine = 'administration_channeling_can_get_engine',
	administration_channeling_can_get_rule = 'administration_channeling_can_get_rule',

	//User management
	administration_user_management_users_list = 'user_management_users_list',
	administration_user_management_user_detail = 'user_management_user_detail',
	administration_user_management_center_list = 'user_management_center_list',
	administration_user_management_center_detail = 'user_management_center_detail',
	administration_user_management_user_toggle = 'user_management_user_toggle',
	administration_user_management_create_user = 'user_management_create_user',
	administration_user_management_modify_user = 'user_management_modify_user',
	administration_user_management_superadmin = 'administration_user_management_superadmin',
	administration_user_management_reader = 'administration_user_management_reader'
}

export const FLOTTA_POOL_PROFILES: string[] = ['flotta-pool_dev', 'flotta-pool_center_super_user', 'flotta-pool_assistance_center'];
export const PROFILE_BOOKINGS_RELIEF_MYALD: string = 'module_relief_myald';
export const RELIEF_CENTER_SUPER_USER: string = 'module_relief_center_super_user';
export const PRELEASE_CENTER_SUPER_USER: string = 'module_prelease_center_super_user';
export const BOOKINGS_PROFILES: string[] = [
	RELIEF_CENTER_SUPER_USER,
	PROFILE_BOOKINGS_RELIEF_MYALD,
	PRELEASE_CENTER_SUPER_USER,
	...Object.keys(BookingsProfileKey)
];

export const BOOKINGS_RELIEF_PROFILES: string[] = [
	RELIEF_CENTER_SUPER_USER,
	PROFILE_BOOKINGS_RELIEF_MYALD,
	...Object.keys(BookingsReliefProfileKey),
	NEMO_MOBILITY_BOOKINGS_RELIEF_CA_PILOT,
]
export const BOOKINGS_PRELEASE_PROFILES: string[] = [
	PRELEASE_CENTER_SUPER_USER,
	...Object.keys(BookingsPreleaseProfileKey)
]


export enum FlottaPoolUserPermissions {
	// Header permissions
	flotta_pool_user_can_view_dashboard = 'flotta_pool_user_can_view_dashboard',
	flotta_pool_user_can_view_insert = 'flotta_pool_user_can_view_insert',
	flotta_pool_user_can_view_transfer = 'flotta_pool_user_can_view_transfer',
	flotta_pool_user_can_view_vehicles_fleet = 'flotta_pool_user_can_view_vehicles_fleet',
	// *
	flotta_pool_user_can_view_cluster = 'flotta_pool_user_can_view_cluster',
	flotta_pool_user_can_delete_cluster = 'flotta_pool_user_can_delete_cluster',
	flotta_pool_user_can_add_cluster = 'flotta_pool_user_can_add_cluster',
	flotta_pool_user_can_update_cluster = 'flotta_pool_user_can_update_cluster',

	flotta_pool_user_can_view_cluster_type = 'flotta_pool_user_can_view_cluster_type',
	flotta_pool_user_can_delete_cluster_type = 'flotta_pool_user_can_delete_cluster_type',
	flotta_pool_user_can_add_cluster_type = 'flotta_pool_user_can_add_cluster_type',
	flotta_pool_user_can_update_cluster_type = 'flotta_pool_user_can_update_cluster_type',

	flotta_pool_user_can_view_help_center = 'flotta_pool_user_can_view_help_center',
	flotta_pool_user_can_view_history = 'flotta_pool_user_can_view_history',
	flotta_pool_user_can_view_settings = 'flotta_pool_user_can_view_settings',

	// *

	// CTA permissions
	flotta_pool_cluster_can_delete_cluster = 'authority_sla_notification',

			flotta_pool_user_can_upload_file = 'flotta_pool_user_can_upload_file',
			flotta_pool_user_can_assign_vehicles_to_center = 'flotta_pool_user_can_assign_vehicles_to_center',
			flotta_pool_user_can_change_vehicles_statuses = 'flotta_pool_user_can_change_vehicles_statuses',
			flotta_pool_user_can_deactivate_vehicles = 'flotta_pool_user_can_deactivate_vehicles',
			flotta_pool_user_can_transfer_vehicles = 'flotta_pool_user_can_transfer_vehicles',
			flotta_pool_user_can_change_vehicles_assign = 'flotta_pool_user_can_change_vehicles_assign',
			flotta_pool_user_can_assign_cluster = 'flotta_pool_user_can_assign_cluster',
			flotta_pool_user_can_unassign_cluster = 'flotta_pool_user_can_unassign_cluster',
			flotta_pool_user_can_suspend_vehicles = 'flotta_pool_user_can_suspend_vehicles',
			flotta_pool_user_can_activate_vehicles = 'flotta_pool_user_can_activate_vehicles',
			flotta_pool_user_can_activate_vehicles_in_transfer = 'flotta_pool_user_can_activate_vehicles_in_transfer',
			flotta_pool_user_can_close_vehicles = 'flotta_pool_user_can_close_vehicles',
			flotta_pool_user_can_confirm_vehicles = 'flotta_pool_user_can_confirm_vehicles',
			flotta_pool_user_can_set_double_keys = 'flotta_pool_user_can_set_double_keys',
			flotta_pool_user_can_set_double_keys_date = 'flotta_pool_user_can_set_double_keys_date',
			flotta_pool_user_can_do_checklist = 'flotta_pool_user_can_do_checklist',
			flotta_pool_user_can_see_insurance_stickers = 'flotta_pool_user_can_see_insurance_stickers',
			flotta_pool_user_can_view_commodities_list = 'flotta_pool_user_can_view_commodities_list',
			flotta_pool_user_can_view_dashboard_new_entry_vehicles = 'flotta_pool_user_can_view_dashboard_new_entry_vehicles',
			flotta_pool_user_can_view_dashboard_closed_vehicles = 'flotta_pool_user_can_view_dashboard_closed_vehicles',
			flotta_pool_user_can_view_dashboard_pool_fleet_vehicles = 'flotta_pool_user_can_view_dashboard_pool_fleet_vehicles',
			flotta_pool_user_can_view_dashboard_usage_indexes_vehicles = 'flotta_pool_user_can_view_dashboard_usage_indexes_vehicles',
			flotta_pool_user_can_get_in_charge_car = 'flotta_pool_user_can_get_in_charge_car',
			flotta_pool_user_can_send_mail = 'flotta_pool_user_can_send_mail',
			flotta_pool_user_can_do_checkout = 'flotta_pool_user_can_do_checkout',
			flotta_pool_user_can_do_checkin = 'flotta_pool_user_can_do_checkin',

			flotta_pool_user_can_remove_vehicles_inventory = 'flotta_pool_user_can_remove_vehicles_inventory',
			flotta_pool_user_can_ok_vehicles_inventory = 'flotta_pool_user_can_ok_vehicles_inventory',
			flotta_pool_user_can_ko_vehicles_inventory = 'flotta_pool_user_can_ko_vehicles_inventory',
			flotta_pool_user_can_missing_vehicles_inventory = 'flotta_pool_user_can_missing_vehicles_inventory',
			flotta_pool_user_can_required_photo_vehicles_inventory = 'flotta_pool_user_can_required_photo_vehicles_inventory',

			flotta_pool_user_can_send_note_vehicles_inventory = 'flotta_pool_user_can_send_note_vehicles_inventory',
			flotta_pool_user_can_send_inventory_vehicles_inventory = 'flotta_pool_user_can_send_inventory_vehicles_inventory',
			flotta_pool_user_can_add_attachment_vehicles_inventory = 'flotta_pool_user_can_add_attachment_vehicles_inventory',
			flotta_pool_user_can_delete_attachment_vehicles_inventory = 'flotta_pool_user_can_delete_attachment_vehicles_inventory',
			flotta_pool_user_can_add_vehicles_inventory = 'flotta_pool_user_can_add_vehicles_inventory'

	/*flotta_pool_user_can_remove_vehicles_inventory = 'flotta_pool_user_can_view_history',
	flotta_pool_user_can_ok_vehicles_inventory = 'flotta_pool_user_can_view_history',
	flotta_pool_user_can_ko_vehicles_inventory = 'flotta_pool_user_can_view_history',
	flotta_pool_user_can_missing_vehicles_inventory = 'flotta_pool_user_can_view_history',
	flotta_pool_user_can_required_photo_vehicles_inventory = 'flotta_pool_user_can_view_history',*/
}

export enum SuperUserPermissions {
	super_user_can_read_all = 'can_read_all',
}

export enum BookingsPermissions {
	Bookingscan_read_all = 'can_read_all',
	bookings_relief_can_digitally_sign_dossier = 'bookings_relief_can_digitally_sign_dossier',
	bookings_relief_can_retrieve_vehicle_data_from_miles = 'bookings_relief_can_retrieve_vehicle_data_from_miles',
	bookings_relief_can_retrieve_vehicles_group_list = 'bookings_relief_can_retrieve_vehicles_group_list',
	bookings_relief_can_retrieve_short_term_vehicles_list = 'bookings_relief_can_retrieve_short_term_vehicles_list',
	bookings_relief_can_retrieve_short_term_vehicle_checklist = 'bookings_relief_can_retrieve_short_term_vehicle_checklist',
	bookings_relief_can_retrieve_notification_settings = 'bookings_relief_can_retrieve_notification_settings',
	bookings_relief_can_retrieve_settings = 'bookings_relief_can_retrieve_settings',
	bookings_relief_can_update_settings = 'bookings_relief_can_update_settings',
	bookings_relief_can_update_renter_booking_request = 'bookings_relief_can_update_renter_booking_request',
	bookings_relief_can_confirm_renter_booking_request = 'bookings_relief_can_confirm_renter_booking_request',
	bookings_relief_can_do_renter_vehicle_checkin = 'bookings_relief_can_do_renter_vehicle_checkin',
	bookings_relief_can_do_renter_vehicle_checkout = 'bookings_relief_can_do_renter_vehicle_checkout',
	bookings_relief_can_change_status_to_noshow = 'bookings_relief_can_change_status_to_noshow',
	bookings_relief_can_change_status_to_noauto = 'bookings_relief_can_change_status_to_noauto',
	bookings_relief_can_retrieve_renter_center_list = 'bookings_relief_can_retrieve_renter_center_list',
	bookings_relief_can_retrieve_finance_flags = 'bookings_relief_can_retrieve_finance_flags',
	bookings_relief_can_approve_whatchlisted_bookings = 'bookings_relief_can_approve_whatchlisted_bookings',
	bookings_relief_can_deny_whatchlisted_bookings = 'bookings_relief_can_deny_whatchlisted_bookings',
	bookings_relief_can_retrieve_accessories_list = 'bookings_relief_can_retrieve_accessories_list',
	bookings_relief_can_retrieve_bookings_list = 'bookings_relief_can_retrieve_bookings_list',
	bookings_relief_can_retrieve_booking_details = 'bookings_relief_can_retrieve_booking_details',
	bookings_relief_can_retrieve_booking_logs = 'bookings_relief_can_retrieve_booking_logs',
	bookings_relief_can_create_booking = 'bookings_relief_can_create_booking',
	bookings_relief_can_update_booking = 'bookings_relief_can_update_booking',
	bookings_relief_can_delete_booking = 'bookings_relief_can_delete_booking',
	bookings_relief_can_approve_bookings = 'bookings_relief_can_approve_bookings',
	bookings_relief_can_unlock_booking = 'bookings_relief_can_unlock_booking',
	bookings_relief_can_confirm_booking = 'bookings_relief_can_confirm_booking',
	bookings_relief_can_put_back_to_work_booking = 'bookings_relief_can_put_back_to_work_booking',
	bookings_relief_can_request_vehicle = 'bookings_relief_can_request_vehicle',
	bookings_relief_can_book_vehicle = 'bookings_relief_can_book_vehicle',
	bookings_relief_can_view_customer_information_without_vehicle_group = 'bookings_relief_can_view_customer_information_without_vehicle_group',
	bookings_relief_can_view_customer_information_without_ald_data = 'bookings_relief_can_view_customer_information_without_ald_data',
	bookings_relief_can_view_customer_detail_information = 'bookings_relief_can_view_customer_detail_information',
	bookings_relief_can_retrieve_rac_center_list = 'bookings_relief_can_retrieve_rac_center_list',
	bookings_relief_can_retrieve_supplier_list = 'bookings_relief_can_retrieve_supplier_list',
	bookings_relief_can_add_lock_note = 'bookings_relief_can_add_lock_note',
	bookings_relief_can_retrieve_rac_list = 'bookings_relief_can_retrieve_rac_list',
	bookings_relief_can_retrieve_customer_vip_list = 'bookings_relief_can_retrieve_customer_vip_list',
	bookings_relief_can_retrieve_plate_vip_list = 'bookings_relief_can_retrieve_plate_vip_list',
	bookings_relief_can_set_customer_vip_status = 'bookings_relief_can_set_customer_vip_status',
	bookings_relief_can_set_plate_vip_status = 'bookings_relief_can_set_plate_vip_status',
	bookings_relief_can_retrieve_reservation_reason_list = 'bookings_relief_can_retrieve_reservation_reason_list',
	bookings_relief_can_retrieve_operation_list = 'bookings_relief_can_retrieve_operation_list',
	bookings_relief_can_view_dashboard = 'bookings_relief_can_view_dashboard',
	bookings_relief_can_retrieve_aci_list = 'bookings_relief_can_retrieve_aci_list',
	bookings_relief_can_retrieve_history_list = 'bookings_relief_can_retrieve_history_list',
	ookings_relief_can_retrieve_customer_vip_list = 'ookings_relief_can_retrieve_customer_vip_list',
	bookings_relief_myald_can_create_booking = 'bookings_relief_myald_can_create_booking',
	bookings_relief_can_retrieve_attachments = 'bookings_relief_can_retrieve_attachments',
	bookings_relief_can_add_attachment = 'bookings_relief_can_add_attachment',
	bookings_relief_can_update_customer_theft = 'bookings_relief_can_update_customer_theft',
	bookings_relief_can_update_plate_theft = 'bookings_relief_can_update_plate_theft',

	bookings_prelease_can_retrieve_vehicle_data_from_miles = 'bookings_prelease_can_retrieve_vehicle_data_from_miles',
	bookings_prelease_can_retrieve_vehicles_group_list = 'bookings_prelease_can_retrieve_vehicles_group_list',
	bookings_prelease_can_retrieve_short_term_vehicles_list = 'bookings_prelease_can_retrieve_short_term_vehicles_list',
	bookings_prelease_can_retrieve_short_term_vehicle_checklist = 'bookings_prelease_can_retrieve_short_term_vehicle_checklist',
	bookings_prelease_can_retrieve_notification_settings = 'bookings_prelease_can_retrieve_notification_settings',
	bookings_prelease_can_retrieve_settings = 'bookings_prelease_can_retrieve_settings',
	bookings_prelease_can_update_settings = 'bookings_prelease_can_update_settings',
	bookings_prelease_can_update_renter_booking_request = 'bookings_prelease_can_update_renter_booking_request',
	bookings_prelease_can_confirm_renter_booking_request = 'bookings_prelease_can_confirm_renter_booking_request',
	bookings_prelease_can_do_renter_vehicle_checkin = 'bookings_prelease_can_do_renter_vehicle_checkin',
	bookings_prelease_can_do_renter_vehicle_checkout = 'bookings_prelease_can_do_renter_vehicle_checkout',
	bookings_prelease_can_change_status_to_noshow = 'bookings_prelease_can_change_status_to_noshow',
	bookings_prelease_can_change_status_to_noauto = 'bookings_prelease_can_change_status_to_noauto',
	bookings_prelease_can_retrieve_renter_center_list = 'bookings_prelease_can_retrieve_renter_center_list',
	bookings_prelease_can_retrieve_finance_flags = 'bookings_prelease_can_retrieve_finance_flags',
	bookings_prelease_can_approve_whatchlisted_bookings = 'bookings_prelease_can_approve_whatchlisted_bookings',
	bookings_prelease_can_deny_whatchlisted_bookings = 'bookings_prelease_can_deny_whatchlisted_bookings',
	bookings_prelease_can_retrieve_accessories_list = 'bookings_prelease_can_retrieve_accessories_list',
	bookings_prelease_can_retrieve_bookings_list = 'bookings_prelease_can_retrieve_bookings_list',
	bookings_prelease_can_retrieve_booking_details = 'bookings_prelease_can_retrieve_booking_details',
	bookings_prelease_can_retrieve_booking_logs = 'bookings_prelease_can_retrieve_booking_logs',
	bookings_prelease_can_create_booking = 'bookings_prelease_can_create_booking',
	bookings_prelease_can_update_booking = 'bookings_prelease_can_update_booking',
	bookings_prelease_can_delete_booking = 'bookings_prelease_can_delete_booking',
	bookings_prelease_can_approve_bookings = 'bookings_prelease_can_approve_bookings',
	bookings_prelease_can_unlock_booking = 'bookings_prelease_can_unlock_booking',
	bookings_prelease_can_confirm_booking = 'bookings_prelease_can_confirm_booking',
	bookings_prelease_can_put_back_to_work_booking = 'bookings_prelease_can_put_back_to_work_booking',
	bookings_prelease_can_request_vehicle = 'bookings_prelease_can_request_vehicle',
	bookings_prelease_can_book_vehicle = 'bookings_prelease_can_book_vehicle',
	bookings_prelease_can_view_customer_information_without_vehicle_group = 'bookings_prelease_can_view_customer_information_without_vehicle_group',
	bookings_prelease_can_view_customer_information_without_ald_data = 'bookings_prelease_can_view_customer_information_without_ald_data',
	bookings_prelease_can_view_customer_detail_information = 'bookings_prelease_can_view_customer_detail_information',
	bookings_prelease_can_retrieve_rac_center_list = 'bookings_prelease_can_retrieve_rac_center_list',
	bookings_prelease_can_retrieve_supplier_list = 'bookings_prelease_can_retrieve_supplier_list',
	bookings_prelease_can_add_lock_note = 'bookings_prelease_can_add_lock_note',
	bookings_prelease_can_retrieve_rac_list = 'bookings_prelease_can_retrieve_rac_list',
	bookings_prelease_can_retrieve_customer_vip_list = 'bookings_prelease_can_retrieve_customer_vip_list',
	bookings_prelease_can_retrieve_plate_vip_list = 'bookings_prelease_can_retrieve_plate_vip_list',
	bookings_prelease_can_set_customer_vip_status = 'bookings_prelease_can_set_customer_vip_status',
	bookings_prelease_can_set_plate_vip_status = 'bookings_prelease_can_set_plate_vip_status',
	bookings_prelease_can_retrieve_reservation_reason_list = 'bookings_prelease_can_retrieve_reservation_reason_list',
	bookings_prelease_can_retrieve_operation_list = 'bookings_prelease_can_retrieve_operation_list',
	bookings_prelease_can_view_dashboard = 'bookings_prelease_can_view_dashboard',
	bookings_prelease_can_retrieve_aci_list = 'bookings_prelease_can_retrieve_aci_list',
	bookings_prelease_can_retrieve_history_list = 'bookings_prelease_can_retrieve_history_list',
	ookings_prelease_can_retrieve_customer_vip_list = 'ookings_prelease_can_retrieve_customer_vip_list',
	bookings_prelease_myald_can_create_booking = 'bookings_prelease_myald_can_create_booking',
	bookings_prelease_can_retrieve_attachments = 'bookings_prelease_can_retrieve_attachments',
	bookings_prelease_can_add_attachment = 'bookings_prelease_can_add_attachment',
	bookings_prelease_can_digitally_sign_dossier = 'bookings_prelease_can_digitally_sign_dossier',
	bookings_prelease_can_update_customer_theft =  'bookings_prelease_can_update_customer_theft',
	bookings_prelease_can_update_plate_theft = 'bookings_prelease_can_update_plate_theft'
}
